import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../../store/rootReducer';
import Button from '../../Button';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'qs';
import TableEmpty from '../../common/TableEmpty';
import styled from 'styled-components';

interface IProps {
  setTab: (tab: string) => void;
}

const TableEmptyBlock = styled.div`
    font-size: 12px;
    color: #999;
    padding: 50px 0;
    background-color: #fbfbfc;
    text-align: center;
`

const ClassAllocateResult: FC<IProps> = ({
  setTab,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  const campusCode = query.campus;
  const { chosenClass } = useSelector((state: RootState) => state.class);

  const [studentName, setStudentName] = useState('');
  const [memberCode, setMemberCode] = useState('');

  useEffect(() => {
    const name = sessionStorage.getItem('studentKorName');
    if (name) {
      setStudentName(name);
      sessionStorage.removeItem('studentKorName');
    }
    const memberCode = sessionStorage.getItem('memberCode');
    if (memberCode) {
      setMemberCode(memberCode);
      sessionStorage.removeItem('memberCode');
    }
  }, []);

  return (
    <>
      <TableEmptyBlock className={'comm-nodata-area mt-0'}>
        <u>{studentName}</u> {t('class.class.text13')} [{chosenClass?.className}] {t('class.class.text14')}
      </TableEmptyBlock>
      <div className="comm-bx__between">
        <div className="comm-btn__area">
          <Button
            className="btn-basic gray-line"
            onClick={() => setTab('register')}
            text={t('common.button.list')}
          />
        </div>
        <div className="comm-btn__area right">
          <Button
            className="btn-basic pink-line"
            onClick={() => {
              history.push(`/student/student?memberCode=${memberCode}&campusCode=${campusCode}&tabIndex=3`);
            }}
            text={t('class.class.button5')}
          />
          <Button
            className="btn-basic pink-line"
            onClick={() => setTab('allocateStudent')}
            text={t('class.class.button6')}
          />
        </div>
      </div>
    </>
  );
};

export default ClassAllocateResult;
